var FcLocationGroupsInputModule = /** @class */ (function () {
    function FcLocationGroupsInputModule() {
    }
    return FcLocationGroupsInputModule;
}());
export { FcLocationGroupsInputModule };
